export const GLASSY_BRAND = 'GLS';
export const NOMAD_BRAND = 'NOMAD';
export const SCCOM_BRAND = 'SCCOM';
export const NGU1_BRAND = 'NGU1';
export const NGU2_BRAND = 'NGU2';
export const NPE_BRAND = 'NPE';
export const NBR_BRAND = 'NBR';
export const SK1_BRAND = 'SK1';
export const SK2_BRAND = 'SK2';
export const COM_BRAND = 'COM';
export const PRJ3_BRAND = 'PRJ3';
export const PRJ4_BRAND = 'PRJ4';

export const NOMAD_GROUP_BRANDS = [
  NOMAD_BRAND,
  NGU2_BRAND,
  NPE_BRAND,
  NBR_BRAND,
];

export const NO_NAME_BRANDS = [
  GLASSY_BRAND,
  NOMAD_BRAND,
  NGU1_BRAND,
  NGU2_BRAND,
  SCCOM_BRAND,
  NPE_BRAND,
  NBR_BRAND,
  SK1_BRAND,
  SK2_BRAND,
  PRJ3_BRAND,
  PRJ4_BRAND,
  COM_BRAND,
];
